import { __awaiter } from "tslib";
import { writable } from 'svelte/store';
import stringify from 'fast-json-stable-stringify';
export var Access;
(function (Access) {
    Access["Allow"] = "allow";
    Access["Deny"] = "deny";
    Access["Inherit"] = "inherit";
})(Access || (Access = {}));
let use_mock = false;
export const jmdb_error = writable("");
export function deep_copy(data) {
    return JSON.parse(JSON.stringify(data));
}
function invalidate() {
    this.invalid = true;
}
function refetch(cb) {
    let store = this;
    if (!store.invalid) {
        return null;
    }
    this.invalid = false;
    let errHandler = (reason) => {
        jmdb_error.set(reason);
    };
    if (use_mock) {
        if (store.cb && cb) {
            store.cb.then(cb);
            return null;
        }
        let ret = new Promise((resolve, reject) => {
            setTimeout(() => {
                let val = { ready: true, data: mock_data[store.url] };
                store.set(val);
                store.cb = null;
                console.log(`Got ${store.url}`);
                resolve(store);
            }, Math.random() * 2000);
        });
        store.cb = ret;
        return ret;
    }
    else {
        if (store.cb) {
            store.cb.then(cb);
            return null;
        }
        let ret = new Promise((resolve, reject) => {
            fetch(store.url).then((resp) => __awaiter(this, void 0, void 0, function* () {
                resp.json().then((ret) => {
                    let val = { ready: true, data: ret };
                    store.set(val);
                    store.cb = null;
                    resolve(store);
                }, errHandler);
            }), errHandler);
        });
        store.cb = ret;
        return ret;
    }
}
function sync_proto(url) {
    let ret = writable({ ready: false, data: [] });
    ret.url = url;
    ret.cb = null;
    ret.invalid = true;
    ret.invalidate = invalidate;
    ret.fetch = refetch;
    return ret;
}
function tl(t) {
    return t;
}
export const job_names = { 'su': "System administrator", 'viewer': "Viewer", 'team_mgr': "Team manager", 'multi_mgr': "Multi-team manager" };
let max_id = 0x7fffff;
let lastNewId = max_id + 0xffff + 1024;
export const newId = lastNewId;
export function isBuiltin(id) {
    return id >= max_id && id != newId;
}
export function resetTempId() {
    lastNewId = max_id + 0xffff + 1024;
}
resetTempId();
export function newTempId() {
    lastNewId += 1;
    return lastNewId;
}
let mock_data = {};
export const actor_list = sync_proto('/api/v1/actors/');
// mock_data[actor_list.url] = tl<Actor[]>([
//     {id: 1, desc:'', name: "Jilaya Rastachapamundra", job: "multi_mgr", email: "jrcma@rcma.com", role: 20, specialRights: { streamers: 
//         {
//             25: {view: Access.Allow, viewArchive: Access.Inherit, changeSettings: Access.Deny},
//             27: {view: Access.Inherit, viewArchive: Access.Inherit, changeSettings: Access.Inherit}
//         }, streamerGroups: {} }},
//     {id: 4, desc:'', name: "John Vevarke", job: "multi_mgr", email: "john@vv.com", role: 19, specialRights: { streamers: {}, streamerGroups: {} }},
//     {id: 6, desc:'', name: "Juvelak Chatenuntanakel", job: "team_mgr", email: '', role: 20, specialRights: { streamers: {}, streamerGroups: {} }},
//     {id: 9, desc:'', name: "Lee Si Tsun", job: "viewer", email:'', role: 22, specialRights: { streamers: {}, streamerGroups: {} }},
//     {id: 23, desc:'', name: "Newt Scamander", job: "viewer", email:'', role: 21, specialRights: { streamers: {}, streamerGroups: {} }},
//     {id: max_id + 5, desc:'', name: "Super admin", job: "su", email:'', role: max_id + 4, specialRights: { streamers: {}, streamerGroups: {} }},
// ])
export const actor_groups = sync_proto('/api/v1/actor_groups/');
// mock_data[actor_groups.url] = tl<ActorGroup[]>([
//     {id: 10, name: "Alpha", actors: [4, 9]},
//     {id: 11,name: "Beta", actors: [6, 9]},
//     {id: 2, name: "Epsilon", actors: []},
//     {id: 7, name: "Omega", actors: [1]},
//     {id: 18, name: "Working remotely", actors: [6, 9]},
// ])
export const role_groups = sync_proto('/api/v1/role_groups/');
// mock_data[role_groups.url] = tl<RoleGroup[]>([])
export const right_list = sync_proto('/api/v1/rights/');
// mock_data[right_list.url] = tl<NamedRights[]>([
//     {id: 24, name: "View restricted streams", streamers: {}, streamerGroups: {}},
//     {id: 25, name: "View team-only streams", streamers: {}, streamerGroups: {}},
//     {id: 26, name: "View testing streams", streamers: {}, streamerGroups: {}},
// ])
export const role_list = sync_proto('/api/v1/roles/');
// mock_data[role_list.url] = tl<Role[]>([
//     {id: max_id + 4, name: "Global admin", rights: [], specialRights: { streamers: {}, streamerGroups: {} }},
//     {id: 19, name: "Team lead", rights: [4], specialRights: { streamers: {}, streamerGroups: {} }},
//     {id: 20, name: "Team member", rights: [1], specialRights: { streamers: {}, streamerGroups: {} }},
//     {id: 21, name: "Novice", rights: [9], specialRights: { streamers: {}, streamerGroups: {} }},
//     {id: 22, name: "Guest", rights: [4, 9], specialRights: { streamers: {}, streamerGroups: {} }},
// ])
export const streamer_list = sync_proto('/api/v1/streamers/');
// mock_data[streamer_list.url] = tl<Streamer[]>([
//     {id: 23, name: "Dog cam", sid: "33", nid: "UO123"},
//     {id: 25, name: "Cat cam", sid: "34", nid: "UO456"},
//     {id: 26, name: "Parrot cam", sid: "35", nid: "UO789"},
//     {id: 27, name: "Octopus cam", sid: "36", nid: "UO012"},
// ])
export const streamer_groups = sync_proto('/api/v1/streamer_groups/');
// mock_data[streamer_groups.url] = tl<StreamerGroup[]>([
//     {id: 28, name: "Outdoors", streamers: [23, 25]},
//     {id: 29, name: "Indoors", streamers: [26, 27]},
//     {id: 30, name: "Underwater", streamers: [27]},
// ])
export function idArrayKey(v) {
    return v.id;
}
export function diffDict(old, modified) {
    let oldArr = [];
    let modArr = oldArr;
    modArr = [];
    Object.keys(old).forEach((k) => oldArr.push({ id: Number(k), data: old[Number(k)] }));
    Object.keys(modified).forEach((k) => modArr.push({ id: Number(k), data: modified[Number(k)] }));
    let ret = diffArray(oldArr, modArr);
    for (let i = 0; i < ret.Val.length; ++i) {
        if (ret.Val[i] == null)
            continue;
        ret.Val[i] = ret.Val[i].data;
    }
    return ret;
}
export function diffArray(old, modified, key = idArrayKey, hasVal = true) {
    let ret = { From: [], To: [], Val: [] };
    let intersectKeys = new Set(modified.filter((v) => -1 != old.findIndex((o) => key(o) == key(v))).map(key));
    let newKeys = new Set(modified.filter((v) => !intersectKeys.has(key(v))).map(key));
    let delKeys = [...new Set(old.filter((v) => !intersectKeys.has(key(v))).map(key))];
    let change = function (oldId, newId, newVal) {
        if (oldId != null) {
            oldId = Number(oldId);
        }
        if (newId != null) {
            newId = Number(newId);
        }
        ret.From.push(oldId);
        ret.To.push(newId);
        if (hasVal) {
            ret.Val.push(newVal);
        }
    };
    intersectKeys.forEach((itsk) => {
        let oldVal = old.find((v) => key(v) == itsk);
        let newVal = modified.find((v) => key(v) == itsk);
        if (stringify(oldVal) != stringify(newVal)) {
            change(itsk, itsk, newVal);
        }
    });
    newKeys.forEach((newk) => {
        let newVal = modified.find((v) => key(v) == newk);
        let oldKey = null;
        if (delKeys.length) {
            oldKey = delKeys.pop();
        }
        change(oldKey, newk, newVal);
    });
    delKeys.forEach((delk) => {
        change(delk, null, null);
    });
    return ret;
}
